import script from "./TimezoneWarning.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimezoneWarning.vue?vue&type=script&setup=true&lang=ts"

import "./TimezoneWarning.vue?vue&type=style&index=0&id=a177ea90&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a177ea90"]])

export default __exports__